export default __webpack_public_path__ + "video/5b4fee66bca92e9f065c0009fd1292c5.webm";